export default __webpack_public_path__ + "static/media/filter-active.b5efdc68.svg";